import CardsInfoPage from './CardsInfoPage';

export default CardsInfoPage;